import * as React from "react";
import DeviceContext from "../../service/indentifyDevice";
import LoginPopup from "../generic/loginPopup";
import { ELoginScreenState } from "../loginConstants";
import "../../../assets/scss/components/login/loginScreen/openAccountScreen.scss";
import EdButton from "./../../generic/edButton";
import { changeScreen } from "../../service/login/loginService";
import loginURLConfig from "../../../config/login/loginURLConfig";
import logo from "../../../assets/images/logo_white.jpg";

export interface IOpenAccountScreenProps {
	onClose?: () => void;
}

const OpenAccountScreen: React.FC<IOpenAccountScreenProps> = (props) => {
	const content = (
		<div className="open_acc">
			<h1 className="acctyp_head mg-b20">Account type</h1>
			<p className="acctyp mg-b10">Equity</p>
			<p className="text mg-b30">Trade in Equities, Currencies, Derivatives, Mutual Funds, NCDs and ETFs available on NSE and BSE</p>
			<a className="ed_button primary button proceed" href={loginURLConfig.openAccount}>
				Proceed
			</a>
			<p className="text_comm">
				Interested in opening a commodities account?{" "}
				<EdButton className="comm_link" value="Click here" btnTyp="blue-link" onClick={() => changeScreen(ELoginScreenState.LEAD_FORM)} />
			</p>
		</div>
	);

	return DeviceContext().isDesktop ? (
		<div className="open_acc_ppup">
			<div className="img_cont" style={{ background: `url('${process.env.PUBLIC_URL}/images/login/plush-design-studio.png')` }}></div>
			<div className="text_cont">
				<div className="content">
					<header>
						<div className="close_cont">
							<button className="close" onClick={props.onClose}>
								<i className="edel-icon-close" />
							</button>
						</div>
						<div className="logo_cont">
						<img src={logo} alt="nuvama" className="nuvama_logo"/>
						</div>
					</header>
					{content}
					<div className="version">Nuvamawealth.com(TOC) Ver. 1.0.0.5</div>
				</div>
			</div>
		</div>
	) : (
		<LoginPopup leftHeaderContent={<img src={logo} alt="nuvama" className="nuvama_logo"/>} onClose={props.onClose} className="login_scrn">
			{content}
		</LoginPopup>
	);
};

export default OpenAccountScreen;
